import { gql } from "@grandvisionhq/graphql";
import StoreDetailsFragment from "../../../fragments/operations/fragments/store-details.js";
import StoreOffersFragment from "../../../fragments/operations/fragments/store-offers.js";
const GET_STORE_DETAILS = gql`
  query GetStoreDetails($globalStoreId: ID, $deviceGeoLocation: GeoLocationInput, $slug: String) {
    store(globalStoreId: $globalStoreId, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...StoreDetails
      ...StoreOffers
    }
  }
  ${StoreDetailsFragment}
  ${StoreOffersFragment}
`;
export {
  GET_STORE_DETAILS
};
//# sourceMappingURL=get-store-details.js.map
